export default function PageHeader({ title, subtitle, action }) {
  return (
    <div className="mb-4">
      <div className="d-flex justify-content-between align-items-start">
        <div>
          <h4 className="mb-0 fw-bold" style={{
            background: 'var(--gradient-diagonal)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            textTransform: 'uppercase',
            letterSpacing: '.04em',
            fontSize: '1.15rem',
          }}>
            {title}
          </h4>
          {subtitle && <p className="text-muted mb-0 mt-1" style={{ fontSize: '.83rem' }}>{subtitle}</p>}
        </div>
        {action}
      </div>
      <div style={{
        height: 2,
        marginTop: '0.85rem',
        background: 'var(--gradient-diagonal)',
        opacity: .18,
        borderRadius: 99,
      }} />
    </div>
  );
}
